import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LoadingSpinnerService } from '../../services/loading-spinner/loading-spinner.service';
import { BaseObserver } from '../../baseobserver';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'ssg-loading-spinner',
  templateUrl: './loading-spinner.component.html'
})
export class LoadingSpinnerComponent extends BaseObserver  implements OnInit {
  @ViewChild('overlay', { static: true }) overlay: ElementRef;

  constructor(private _service: LoadingSpinnerService) {
    super();
  }

  ngOnInit() {
    this._service.getLoading().subscribe(value => this.overlay.nativeElement.style.display = value ? 'block' : 'none');
  }

}
